import {
  Component,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResetPasswordService } from 'src/app/core/services/resetPassword.service';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-changePassword',
  templateUrl: 'changePassword.component.html',
  styleUrls: ['./changePassword.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  token: string;

  constructor(
    private route: ActivatedRoute,
    private resetPasswordService: ResetPasswordService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.route.params.subscribe((res) => {
      this.token = res.token;
      this.resetPasswordService.checkToken(this.token).subscribe((response) => {
        console.log(response["status"])
        if (response["status"] !== "valid") {
          switch (response["status"]) {
            case "Unreadable token": this.translate.get('changePassword.unreadableToken').subscribe((text: string) => { this.toastr.error(text); }); break;
            case "Expired token": this.translate.get('changePassword.expiredToken').subscribe((text: string) => { this.toastr.error(text); }); break;
            default: this.toastr.error(`Error : ${response["status"]}, please retry`); break;
          }
        }
      });
    })
  }

  sub: Subscription;
  // error = {} as IError;
  isLoading = false;
  isStarting = false;

  ngOnInit(): void {
  }

  /**
   * is for attempting to changePassword with username and password.
   * @param e
   * @param changePasswordForm - is Angluar NgForm with email and password
   * @returns
   */
  attemptToChangePassword(e: KeyboardEvent, changePasswordForm: NgForm) {
    if (e.repeat) {
      return;
    }

    if (changePasswordForm.invalid) {
      return;
    }

    // this.error.message = '';
    this.isLoading = true;

    const { userPassword } = changePasswordForm.value;

    this.resetPasswordService.changePassword(userPassword, this.token).subscribe((response) => {
      this.isLoading = false;
      location.href = `${window.location.href}/login`;
    }, (err) => {
      this.isLoading = false;
      switch (err.error.errorCode) {
        case 4010001: this.translate.get('changePassword.unreadableToken').subscribe((text: string) => { this.toastr.error(text); }); break;
        case 4010002: this.translate.get('changePassword.expiredToken').subscribe((text: string) => { this.toastr.error(text); }); break;
        default: this.toastr.error(err.error.description); break;
      }
    });
  }

  ngOnDestroy() {
    // this.sub.unsubscribe();
  }
}

